module.exports = __webpack_public_path__ + "static/media/card-blog3.47bb87fb.jpg";